import React from 'react';

function Card({ index, name, category, description, image, links }) {
  return (
    <div key={index} className="p-6 bg-white rounded-lg shadow-md flex flex-col gap-3 border border-gray-200">
      <img src={image} alt={name} className="w-10 h-10" />
      <h2 className="text-xl font-semibold">{name}</h2>
      <p className="text-sm text-gray-500">{category}</p>
      <p className="text-gray-700 text-sm">{description}</p>
      <div className="flex gap-2 mt-4">
        <button className="px-3 py-1 bg-gray-200 rounded text-sm">AI Driven</button>
        <a href={links} target="_blank" rel="noopener noreferrer" className='cursor-pointer'>
          <button className="px-3 py-1 bg-black text-white rounded text-sm cursor-pointer">Explore →</button>
        </a>
      </div>
    </div>
  );
}

export default Card;
